/**
 *
 * Asynchronously loads the component for AccessControlRoles
 *
 */
import Loadable from 'react-loadable';
export default Loadable({
    loader: function () { return import(/* webpackChunkName: 'AccessControlRoles' */ './index'); },
    loading: function (props) {
        if (props.error) {
            console.error(props.error);
        }
        return null;
    },
});
